import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Array, AsyncStateN } from '@blade/std-lib'
import { InfoMessage } from '@root/shared/ui-kit'

import { reatomMonitorSquare } from '../../atoms/reatom-monitor-square'

import { TrackedWalletSquare } from './tracked-wallet-square'
import { TrackedWalletSquareSkeleton } from './tracked-wallet-square-skeleton'

import type { ClassNameProps } from '@root/shared/react'

type Props = {} & ClassNameProps

export const MonitorSquare: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()

  const requestStateAtom = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomMonitorSquare(),
    [],
  )
  const [requestState] = useAtom(requestStateAtom)

  const handleRetry = () => {
    // TODO: Val - implement retry
  }

  return AsyncStateN.matchWaiting(requestState, {
    Error: () => (
      <InfoMessage
        intent="error"
        variant="dt"
        withBackground
        onRetry={handleRetry}
        retryText={t('common.retry')}
      />
    ),
    Waiting: () => (
      <Root className={className}>
        {Array.range(1, 4).map((it) => (
          <TrackedWalletSquareSkeleton key={it} />
        ))}
      </Root>
    ),
    Success: (data) => {
      return (
        <Root className={className}>
          {data.map((entry) => (
            <TrackedWalletSquare
              key={entry.pair.address}
              pair={entry.pair}
              makerAddress={entry.makerAddress}
            />
          ))}
        </Root>
      )
    },
  })
}

const Root = styled.div`
  display: grid;
  padding: 8px;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px;
  overflow-y: auto;
`
